import { createSlice } from '@reduxjs/toolkit';
import { ErrorType, RootState } from '../../../app/store';
import { PropertySearchResponseDto, PropertyV2Dto } from '@inosio/payments-sdk';

interface PropertiesDataPage {
  Rows: Array<PropertyV2Dto>;
}
type PMState = {
  Properties: PropertySearchResponseDto;
  PropertiesDataPages: Array<PropertiesDataPage>;
  isFetchingProperties: Boolean;
  isGetPropertiesFailed: Boolean;
  isSuccess: Boolean;
  errorMessage: ErrorType;
  pmPropertiesWithoutPagination: PropertyV2Dto[];
};
const getInitialState = () => {
  return {
    Properties: { TotalCount: 0, RecordStart: 0, RangeSize: 100, Rows: [] },
    PropertiesDataPages: [],
    isFetchingProperties: false,
    isGetPropertiesFailed: false,
    isSuccess: false,
    errorMessage: {} as ErrorType,
    pmPropertiesWithoutPagination: [],
  } as PMState;
};
const pmPropertiesSlice = createSlice({
  name: 'pmProperties',
  initialState: getInitialState(),
  reducers: {
    getPropertiesData(state, action) {
      state.errorMessage = {} as ErrorType;
      state.isGetPropertiesFailed = false;
      state.isFetchingProperties = true;
    },
    setPropertiesData(state, action) {
      const _payload = action.payload;
      let currentPropertyPages = [...state.PropertiesDataPages];
      if (_payload.RecordStart === 0) currentPropertyPages = [];

      const whatPageResultsIsThis = Math.ceil(_payload.RecordStart / _payload.RangeSize);
      currentPropertyPages[whatPageResultsIsThis] = {
        Rows: _payload.Rows,
      };
      const propertiesData = {
        Properties: action.payload,
        PropertiesDataPages: currentPropertyPages,
        isFetchingProperties: false,
        isGetPropertiesFailed: false,
        isSuccess: false,
      };
      return { ...state, ...propertiesData };
    },
    getPropertiesWithoutPagination(state, action) {
      state.errorMessage = {} as ErrorType;
      state.isGetPropertiesFailed = false;
      state.isFetchingProperties = true;
    },
    setPropertiesWithoutPagination(state, action) {
      state.isFetchingProperties = false;
      state.pmPropertiesWithoutPagination = [...action.payload.Rows];
      if (action.payload.TotalCount === 0) {
        state.errorMessage.message = 'No property found by this name';
      }
    },
    getPropertiesDataFailed(state, action) {
      state.isGetPropertiesFailed = true;
      state.isFetchingProperties = false;
      state.errorMessage = action.payload;
      state.isSuccess = false;
    },
    getResetPmPropertiesState(state) {
      state = getInitialState(); //life is good, setting state back to original/default and moving on
      return { ...state };
    },
  },
});
export const { getPropertiesData, setPropertiesData, getPropertiesDataFailed, getPropertiesWithoutPagination, setPropertiesWithoutPagination, getResetPmPropertiesState } = pmPropertiesSlice.actions;

export default pmPropertiesSlice.reducer;
export const selectProperties = (state: RootState) => state.pmPropertyModuleState.Properties;
export const selectPropertiesCurrentPage = (state: RootState) => state.pmPropertyModuleState.PropertiesDataPages;
export const selectPropertiesState = (state: RootState) => state.pmPropertyModuleState;
